import { useSelector, useDispatch } from 'umi';
import { TIPS_VIEW_MODEL_NAMESPACE } from '@user-center/models/tipsView';

import type { ITipsViewState } from '@user-center/models/tipsView';

export default function useTipsView(key: string) {
  const dispatch = useDispatch();

  const { loading: tipsViewLoading, data: tipsView } = useSelector<any, ITipsViewState>(
    (rootState) => rootState?.[TIPS_VIEW_MODEL_NAMESPACE] || {},
  );

  // 修改判断逻辑：loading时不应该认为已查看，只有loading完成且数据中有该key才认为已查看
  const isTipsView = !tipsViewLoading && !!tipsView?.[key];

  const handleViewedTips = (e?: React.SyntheticEvent) => {
    e?.stopPropagation();
    if (!key) return;
    dispatch({
      type: `${TIPS_VIEW_MODEL_NAMESPACE}/updateTipsViewStateTrue`,
      payload: key,
    });
  };

  return { tipsViewLoading, isTipsView, handleViewedTips };
}
